const WaiverFormMinor = require('@/lib/Waivers/WaiverFormMinor');
const { toBool, toInt, toString } = require('@/functions/transform');

class WaiverForm {
    constructor() {
        /**
         * @type {Number}
         */
        this.ID = null;

        /**
         * @type {null}
         */
        this.age = null;

        /**
         * @type {string}
         */
        this.firstName = '';

        /**
         * @type {string}
         */
        this.lastName = '';

        /**
         * @type {boolean}
         */
        this.guardian = false;

        /**
         * @type {WaiverFormMinor[]}
         */
        this.minors = [];
    }

    getHydrationMap() {
        return {
            attending: toBool,
            ID: toInt,
            age: toInt,
            firstName: toString,
            lastName: toString,
            guardian: toBool,
            minors: {
                field: ['minors', 'waiverFormMinors'],
                modelCollection: WaiverFormMinor,
            },
        };
    }
}

module.exports = WaiverForm;
